import { render, staticRenderFns } from "./MenuTabsEditor.vue?vue&type=template&id=235ff9f4&"
import script from "./MenuTabsEditor.vue?vue&type=script&lang=js&"
export * from "./MenuTabsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports